import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const pageHeight = 1056;
export const pdfViewerPageWidth = 816;
export const pdfViewerPageWidthSmall = 300;
export const pdfViewerStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "row",
      maxWidth: 1077,
      margin: "0 auto",
      minHeight: "calc(100vh - 125px)",
      "@media (max-width: 1060px)": {
        flexDirection: "column-reverse",
      }
    },
    backBtnContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      marginTop: 24,
      fontSize: 20,
      cursor: "pointer",
      maxWidth: 1077,
      margin: "0 auto",
      width: "100%",
      paddingLeft: 26
    },
    page: {
      padding: 24,
      width: pdfViewerPageWidth,
      maxWidth: "100%",
      // minWidth: "100%",
      margin: "12px auto 24px",
      minHeight: pageHeight - 48,
      backgroundColor: "rgb(82, 86, 89)",
      "@media (max-width: 816px)": {
        height: "100%",
        minHeight: 0,
        padding: "12px 0",
        width: "100%",
      }
    },
    pageSmall: {
      width: pdfViewerPageWidthSmall,
      maxWidth: "100%",
      minWidth: "100%",
      margin: "0 auto",
      "@media (max-width: 816px)": {
        height: "100%",
        minHeight: 0,
        padding: 0,
        width: "100%",
      }
    },
    pageBorder: {
      border: "1px solid #002655"
    },
    skeleton: {
      transform: "none"
    },
    loader: {
      height: "100%",
      width: "100%",
      minWidth: 300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      minHeight: pageHeight - 48,
      "@media (max-width: 816px)": {
        height: "100%",
        minHeight: 600,
      }
    },
    loaderSmall: {
      height: "100%",
      width: "100%",
      minWidth: 300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },
    loaderText: {
      color: "white",
      fontSize: 18,
      marginTop: 18,
      maxWidth: 200,
      textAlign: "center"
    },
    pageOverlay: {
      position: 'absolute',
      padding: 24,
      maxWidth: pdfViewerPageWidth,
      margin: "24px auto",
      minHeight: pageHeight - 48,
      top: 0,
      left: 0,
      right: 0,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-end",
      "@media (max-width: 816px)": {
        height: "100%",
        minHeight: 0,
        padding: 8,
      },
    },
    dlButton: {
      margin: 12,
      width: "100%"
    },
    buttonsContainer: {
      height: "100%",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "column",
      padding: "24px",
      maxWidth: 240,
      "@media (max-width: 1060px)": {
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        width: "100%",
        paddingBottom: 0,
        maxWidth: "100%",
      }
    },
    downloadButton: {
      backgroundColor: "#F2F4F3 !important",
      color: "#18223C !important",
      minHeight: 50,
      fontSize: "16px !important",
      minWidth: 140
    },
    downloadIcon: {
      color: "#18223C !important"
    },
    navigationContainer: {
      position: 'absolute',
      bottom: 48,
      left: 0,
      right: 0,
      width: "100%",
      padding: 12
    },
    documentContainer: {
      position: "relative",
      width: "100%",
      '&:hover div div': {
        opacity: 1
      },
    },
    navigationContents: {
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      maxWidth: 250,
      borderRadius: 36,
      padding: "6px 12px",
      backgroundColor: "white",
      transition: "opacity ease-in-out 0.3s",
      boxShadow: "0 30px 40px 0 rgb(16 36 94 / 20%)",
      opacity: 0
    },
    navigationLoading: {
      opacity: "0 !important",
      pointerEvents: "none"
    },
    pageNumber: {
      fontSize: 16,
      fontStyle: "italic",
      fontWeight: "bold"
    },
  })
);
